export default class Contact {
  constructor() {
    this.fullname = null;
  }
}
